"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var home_src_1 = require("./home.src");
exports.home = home_src_1.home;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4d5b8a78b9bd1a6f/src/.tmp/home/home.controls.tsx
// module id = 304
// module chunks = 0